import { toIntOrNull } from '@utils/parse';
import { useApiModel } from '@hooks/use-api-model';
import { useApiSubmit } from '@hooks/use-api-submit';
import { DashRegistrationStep } from '@/types/dashboard';
import { defaultScreeningProgress } from '@/types/screening/screening-progress';
import type { IVoucherChoiceFormValues, IVoucherChoiceModel, IVoucherChoiceSubmitResult } from '@/types/screening/voucher-choice';

const VOUCHER_CHOICE_ENDPOINT = '/api/register/voucher-choice';

const defaultVoucherChoiceModel: IVoucherChoiceModel = {
    ...defaultScreeningProgress,
    currentRegistrationStep: DashRegistrationStep.VoucherChoice,

    hasIntendedRecipient: null,
    voucherEducationChoice: null,
    isFromCLM: false,
    isFromPedGallery: false,
    voucherVideoUrl: '',
    showVem: true,
};

export const useVoucherChoice = (registrationId: number, editKey: string) => {
    const url = `${VOUCHER_CHOICE_ENDPOINT}/${registrationId}/${editKey}`;

    const { model, isLoading, error } = useApiModel(url, defaultVoucherChoiceModel);

    const { submit, isSubmitting, submitError } = useApiSubmit<IVoucherChoiceFormValues, DashRegistrationStep, IVoucherChoiceSubmitResult>(
        url,
        (values) => ({
            voucherEducationChoice: toIntOrNull(values.voucherEducationChoice),
        }),
        (nextStep) => ({ nextStep }),
    );

    return { model, isLoading, error, submit, isSubmitting, submitError };
};
